import { getCookieData, IS_ANDROID, IS_IOS } from '@repo/common-utils';
import { MAINTENANCE_SETTING_COOKIE, useWorkingPlatform } from '@repo/platform';
import { useAuthContext } from '@repo/user-session';
import { useRouter } from 'next/router';

import { COMMON_PATHS } from '@/lib/constants/paths';

export const useExitService = () => {
  const { workingPlatform, workingPlatformType } = useWorkingPlatform();
  const { auth } = useAuthContext();
  const router = useRouter();

  const redirectToExitDestination = (path?: string) => {
    const maintenanceSetting = getCookieData(MAINTENANCE_SETTING_COOKIE);
    const pathname = maintenanceSetting?.status || auth.status === 'logout' ? COMMON_PATHS.환급랜딩 : path || COMMON_PATHS.환급조회목록;

    router.replace({
      pathname,
      query: router.query
    });
  };

  const exitService = (path?: string) => {
    if (workingPlatform === 'kbank') {
      if (IS_IOS) {
        window?.webkit?.messageHandlers?.closeKbankWebView?.postMessage('');
      } else if (IS_ANDROID) {
        window?.kbw?.closeKbankWebView();
      }
    } else if (workingPlatformType === 'web' || workingPlatform === 'app') {
      if (workingPlatform === 'app' || !window.opener || window.opener === window) {
        redirectToExitDestination(path);
      } else {
        window.close();

        window.setTimeout(() => {
          if (!document.hidden) {
            redirectToExitDestination(path);
          }
        }, 300);
      }
    } else {
      redirectToExitDestination(path);
    }
  };

  return { exitService };
};
